module.exports = __webpack_public_path__ + "img/au.1ba5f94.svg";